<p-confirmDialog [style]="{width: '50vw'}" acceptLabel="Current Page" rejectLabel="All Pages"
                 [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
                 acceptIcon="pi pi-download"
                 [rejectIcon]="isFileDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                 [baseZIndex]="10000" acceptButtonStyleClass="p-button-secondary"
                 rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>

<p-toast key="error-message" position="top-right"></p-toast>
<p-toast key="success-message" position="top-right"></p-toast>
<p-toast key="user-management" position="top-right"></p-toast>
<div class="p-my-2 p-grid p-ai-center p-jc-between ">
    <div class="p-col-9 p-lg-5 p-xl-4">
                    <span class="p-input-icon-right p-float-label width-100">
                        <input type="text"
                               (change)="onSearch($event)"
                               pInputText class="width-100"/>
                        <label>Search User</label>
						<i class="pi pi-search"></i>
					</span>
    </div>
    <div class="p-col-3 p-lg-5 p-xl-4 p-text-right">
        <button class="p-button-secondary p-button-sm" label="Add User" pButton pRipple
                (click)="navigateToUpdateCurrentUser('new')"></button>
    </div>
</div>

<div class="card p-py-0 p-mt-3">
    <div class="p-grid p-border-bottom p-pb-3 p-pt-3 p-ai-center p-jc-between">
        <div class="p-col-9">
            <h5 class="p-m-0 p-text-primary">Users</h5>
        </div>
        <div class="p-col-3 p-text-right">
            <img pRipple (click)="downloadFiles()" class="fp-icon-height p-cursor"
                 src="assets/branding/shared-icons/export-excel.svg" alt="excel-export">
        </div>
    </div>


    <div class="p-grid p-text-secondary p-ai-center p-border-bottom p-py-2 p-mt-1">
        <div class="p-col-4 p-d-flex p-pl-2">
            <div class="p-d-flex">
                <h5 class="p-my-0 p-mr-2">
                    Email Id
                </h5>
            </div>
        </div>
        <div class="p-col-4">
            <div class="p-d-flex">
                <h5 class="p-my-0 p-mr-2">
                    First Name
                </h5>
            </div>
        </div>
        <div class="p-col-3">
            <div class="p-d-flex">
                <h5 class="p-my-0 p-mr-2">
                    Last Name
                </h5>
            </div>
        </div>
        <div class="p-col-1 p-text-right">
        </div>
    </div>
    <div class="p-grid p-jc-center p-border-bottom p-py-2" *ngIf="isLoading">
        <div class="p-text-center p-pt-5" style="min-height: 20vw;">
            <div>
                <div class="p-text-secondary pi pi-spin pi-spinner"
                     style="font-size: 2rem"></div>
            </div>
            <div class="p-mt-4">
                <h5 class="p-text-light">Loading User's !</h5>
            </div>
        </div>
    </div>
    <div *ngIf="!isLoading" style="max-height: calc(78vh - 8.5rem); overflow-y: scroll; overflow-x: hidden">
        <div class="p-grid p-py-3 p-ai-center p-border-bottom" *ngFor="let user of allUsers">
            <div class="p-col-4 p-d-flex p-pl-2">
                {{user?.emailId ? user?.emailId : '-'}}
            </div>
            <div class="p-col-4">
                {{user?.firstName ? user?.firstName : '-'}}
            </div>
            <div class="p-col-3">
                {{user?.lastName ? user?.lastName : '-'}}
            </div>
            <div class="p-col-1 p-mt-2">
                <div class="p-ai-center p-jc-between p-mt-2">
                    <i class="pi pi-ellipsis-v p-text-primary p-text-bold p-cursor"
                       (click)="handleToggle($event, user)"
                       style="font-size: 1.5rem;"></i>
                </div>
            </div>
        </div>

    </div>

    <div>
        <p-paginator #pagination
                     (onPageChange)="paginateFilteredUsers($event)" [rows]="10"
                     [totalRecords]="pagedUser?.totalElements"></p-paginator>
    </div>

</div>


<p-menu #menu [model]="actionMenu" [popup]="true"></p-menu>

